import Deferred from './deferred'

/**
 * This class is responsible for providing access to
 * information it receives from from the parent page
 */
class ClientInfoService {
  // Communication channel
  _clientLibraryComm = null

  // Client embedder options store
  optionsDeferred = new Deferred()

  // Global Snowplow. context provided by our SDK
  snowplowContextDeferred = new Deferred()

  constructor(clientLibraryComm) {
    this._clientLibraryComm = clientLibraryComm

    this._listenForWidgetOptions()

    this._listenForSnowplowContext()
  }

  /**
   * Listens for optionsRequest and initialize options.
   */
  _listenForWidgetOptions = () => {
    this._clientLibraryComm.listenOnce('options', optionsJson => {
      const options = JSON.parse(optionsJson)

      this.optionsDeferred.resolve(options)
    })

    this._clientLibraryComm.sendMessage('optionsRequest')
  }

  /**
   * Listens for spContextRequest and initialize Snowplow global context.
   */
  _listenForSnowplowContext = () => {
    this._clientLibraryComm.listenOnce('spContext', spContextJson => {
      const context = JSON.parse(spContextJson)

      this.snowplowContextDeferred.resolve(context)
    })

    this._clientLibraryComm.sendMessage('spContextRequest')
  }
}

export default ClientInfoService
